import Model, { attr, belongsTo } from '@ember-data/model'

export default class SegmentModel extends Model
{
	@attr name;
	@attr description;
	@attr('boolean') startIsStart;
	@attr('boolean') endIsFinish;
	@attr('number') distance;

	@belongsTo('course', {inverse: 'segments', async: true}) CourseId;
	@belongsTo('event', {inverse: 'segments', async: true}) EventId;
	@belongsTo('course-element', {inverse: null, async: true}) startCourseElementId;
	@belongsTo('course-element', {inverse: null, async: true}) endCourseElementId;
}
